import { createSlice } from "@reduxjs/toolkit";

interface Imenu {
   value: boolean,
};

const initialState: Imenu = {
   value: false
}

export const toggleMenu = createSlice({
   name: "toggleMenu",
   initialState: initialState,
   reducers: {
      setMenu: (state, action) => {
         state.value = action?.payload;
      },
      //   stopLoading: (state) => {
      //       state.value = false;
      //   },
   },
});

export const { setMenu } = toggleMenu.actions;
// export const getLoadingStatus = (state: any) => state.loading.value;
export default toggleMenu.reducer;